import type { KeyValueStore } from '../core';
import { browserStore } from './loadoutStore';

const KEY = 'critter.vibrate';

/** Default on. Off is the saved string, same shape as the other switches. */
export function parseVibration(raw: string | null): boolean {
  return raw !== 'off' && raw !== 'false';
}

export function loadVibration(store: KeyValueStore = browserStore): boolean {
  return parseVibration(store.getItem(KEY));
}

export function saveVibration(on: boolean, store: KeyValueStore = browserStore): void {
  store.setItem(KEY, on ? 'on' : 'off');
}

export function toggleVibration(store: KeyValueStore = browserStore): boolean {
  const next = !loadVibration(store);
  saveVibration(next, store);
  return next;
}
